import { Button } from "./Button";
import { ButtonWrapperProps } from "../../../types";
import { primaryOutlineClass, primarySolidClass } from "./buttonStyles";

export const PrimaryButton = ({
  children,
  cssClass,
  variant = "solid",
  disabled,
  testId,
  onClick,
}: ButtonWrapperProps) => {
  return (
    <Button
      testId={testId}
      disabled={disabled}
      onClick={() => onClick && onClick()}
      cssClass={`${
        variant === "outline" ? primaryOutlineClass : primarySolidClass
      } ${cssClass ? cssClass : ""}`}
    >
      {children}
    </Button>
  );
};
